import React, { ChangeEvent, Fragment, FunctionComponent, SyntheticEvent, useContext } from "react";

//MUI
import { SimpleTreeView } from '@mui/x-tree-view/SimpleTreeView'
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";

//OL
import OlBaseLayer from "ol/layer/Base";
import OlLayerGroup from "ol/layer/Group";
import OlCollection from "ol/Collection";

//Custom components
import PublicLayerTreeItem from "./PublicLayerTreeItem";
import MapContext from "@/components/Map/MapContext";
import { findLayer, flattenLayers } from "@/lib/olHelpers";

//Types
import { MapContextType } from "@/@types/context/MapContext";
import { isBigInt64Array } from "util/types";
import { IconButton } from "@mui/material";

interface IPublicLayerTreeProps {
  ready: boolean;
  layersCollection: OlCollection<OlBaseLayer>;
  onLayerVisibilityChange: (layer: OlBaseLayer, isVisible: boolean) => void;
}

const ExpandIcon = () => (
  <IconButton size="small">
    <ChevronRightIcon />
  </IconButton>
);
const CollapseIcon = () => (
  <IconButton size="small">
    <ExpandMoreIcon />
  </IconButton>
);


const PublicLayerTree: FunctionComponent<IPublicLayerTreeProps> = (props) => {
  const { ready, layersCollection, onLayerVisibilityChange } = props;

  const mapContext = useContext(MapContext) as MapContextType;

  const [expanded, setExpanded] = React.useState<string[]>([]);

  const visibility = mapContext?.getLayerVisibility();
  // const hiddenLayers = visibility ? Object.keys(visibility).filter((key) => visibility[key] === false) : [];
  // console.log(hiddenLayers);

  // const allLayers = flattenLayers(layersCollection.getArray()).filter((x) => !(x instanceof OlLayerGroup));
  // console.log(allLayers);

  //const visibleLayers = allLayers.filter((x) => hiddenLayers.indexOf(x.get("id")) === -1);
  // console.log(visibleLayers);

  // const selected = visibleLayers.map(x => x.get("id"));
  const selected: string[] = [];

  const isVisible = (layer: OlBaseLayer) => {
    const id = layer.get("id");
    return visibility.hasOwnProperty(id) && visibility[id] === false ? false : true;
  };

  const handleToggle = (evt: SyntheticEvent | null, nodeIds: string[]): void => {
    setExpanded(nodeIds);
  };

  const handleSelect = (evt: SyntheticEvent | ChangeEvent<{}> | null, nodeIds: string[] | string): void => {

    if (!evt) return;

    evt.preventDefault(); //prevent onNodeToggle

    if (Array.isArray(nodeIds)) {
    } else {
      if (nodeIds === "app-msp" || nodeIds === "app-drzavna-granica") {
        return;
      }

      const layer = flattenLayers(layersCollection.getArray(), 5).find((x) => x.get("id") === nodeIds);
      if (layer) {
        const layer_visible = isVisible(layer);

        const isGroup = layer instanceof OlLayerGroup;
        if (isGroup) {
          const childLayers = flattenLayers(layer.getLayers().getArray() as OlBaseLayer[], 5);

          const childsVisible = childLayers
            ? childLayers.filter((x: OlBaseLayer) => isVisible(x) === true && !(x instanceof OlLayerGroup))
            : [];

          const childsHidden = childLayers
            ? childLayers.filter((x: OlBaseLayer) => isVisible(x) === false && !(x instanceof OlLayerGroup))
            : [];

          const groupChecked = childsVisible.length > 0;
          const groupIndeterminate = childsVisible.length > 0 && childsHidden.length > 0;

          let newVisible: boolean;

          if (groupIndeterminate) {
            newVisible = true;
          } else {
            newVisible = !groupChecked;
          }

          if (newVisible === true) {
            childsHidden.forEach((l) => {
              const lid = l.get("id");
              // l.setVisible(true);
              mapContext.setLayerVisibility(lid, true);
            });
          } else {
            childsVisible.forEach((l) => {
              const lid = l.get("id");
              l.setVisible(false);
              mapContext.setLayerVisibility(lid, false);
            });
          }
        } else {
          // layer.setVisible(!layer_visible);
          mapContext.setLayerVisibility(nodeIds, !layer_visible);
        }

        onLayerVisibilityChange(layer, !layer_visible);
      }
    }
  };

  const layers = layersCollection.getArray();

  return (
    <Fragment>
      {ready && layers.length > 0 ? (
        <SimpleTreeView
          multiSelect
          checkboxSelection
          slots={{ expandIcon: ExpandIcon, collapseIcon: CollapseIcon }}
          expandedItems={expanded || []}
          selectedItems={selected}
          onSelectedItemsChange={handleSelect}
          onExpandedItemsChange={handleToggle}
          sx={{
            p: 0,
            mb: 0,
          }}
        >
          {layers.map((layer) => (
            <PublicLayerTreeItem key={`lti-${layer.get('id')}`} layer={layer} onNodeSelect={handleSelect} />
          ))}
        </SimpleTreeView>
      ) : null}
    </Fragment>
  );
};

export default PublicLayerTree;
